import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { footer, footerContainer } from './Footer.styles';

type EndorsementFormFooterProps = {
	onClick: () => void;
};

export const EndorsementFormFooter: React.FC<EndorsementFormFooterProps> = ({ onClick }) => {
	return (
		<footer className={footer()} data-testid="endorsement-form-footer">
			<div className={footerContainer()}>
				<Text variant="body" size="medium" fontWeight="normal" className="text-typography-weak">
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.add.footer_text_support" />
				</Text>

				<Button
					variant="primary"
					size="large"
					onClick={onClick}
					data-testid="endorsement-next-button"
					data-qa="endorsement-next-button"
				>
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.add.next_button" />
				</Button>
			</div>
		</footer>
	);
};
